import type { RailwayService, RailwaySession } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'
import { listRailwayServices } from './list-railway-services.js'
import { parseService } from './parse-service.js'

export async function ensureRailwayAppService(
  session: RailwaySession,
  cwd: string,
  requestedName = 'web'
): Promise<RailwayService> {
  const services = await listRailwayServices(session, cwd)
  const existing = services.find(
    (service) =>
      service.id.toLowerCase() === requestedName.toLowerCase() ||
      service.name.toLowerCase() === requestedName.toLowerCase()
  )
  if (existing) return existing

  const result = await runRailway(session.runner, ['add', '--service', requestedName, '--json'], {
    cwd,
    mode: 'capture',
    env: session.env
  })
  const created = result.success
    ? parseService(parseRailwayJson<unknown>(result.stdout))
    : undefined
  if (!created) {
    throw new Error(
      outputTail(`${result.stdout}\n${result.stderr}`) ??
        `Could not create Railway service ${requestedName}.`
    )
  }
  return created
}
